import { Component, OnInit } from '@angular/core';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Router, ActivatedRoute } from "@angular/router";

import { ProgramaService } from '../../services/programa.service';

@Component({
    selector: 'app-programa',
    templateUrl: './programa.component.html',
    styleUrls: ['./programa.component.css'],
    standalone: false
})
export class ProgramaComponent implements OnInit {
  total = 11;
  loading = true;
  search; //String que irá guardar o que o usuário quer pesquisar
  isVisibleCancelFiltro = false;
  pageSize = 10;
  pageIndex = 1;
  isVisibleDetalhe = false;
  programas = [];

  constructor(
    private message: NzMessageService,
    private route: ActivatedRoute,
    private router: Router,
    private programaService: ProgramaService,
  ) { }
  ngOnInit(): void {
  }

  ativar(idprograma) {
    let idLoading = this.message.loading('Ativando programa...').messageId;
    this.programaService.ativar(idprograma).subscribe((i: any) => {
      this.message.remove(idLoading);
      this.message.success('Ativação realizada com SUCESSO!');
      this.loading = true;
      this.programaService.all(this.pageIndex).subscribe((m: any) => {
        this.programas = m.data.programa.data;
        this.total = m.data.programa.total;
        this.pageSize = m.data.programa.per_page;
        this.loading = false;
      });
    });
  }

  inativar(idprograma) {
    let idLoading = this.message.loading('Inativando programa...').messageId;
    this.programaService.inativar(idprograma).subscribe((i: any) => {
      this.message.remove(idLoading);
      this.message.success('Inativação realizada com SUCESSO!');
      this.loading = true;
      this.programaService.all(this.pageIndex).subscribe((m: any) => {
        this.programas = m.data.programa.data;
        this.total = m.data.programa.total;
        this.pageSize = m.data.programa.per_page;
        this.loading = false;
      });
    });
  }


  onQueryParamsChange(params: NzTableQueryParams): void {
    this.programaService.all(params.pageIndex).subscribe((m: any) => {
      this.pageIndex = params.pageIndex;
      this.programas = m.data.programa.data;
      this.total = m.data.programa.total;
      this.pageSize = m.data.programa.per_page;
      this.loading = false;
    });
  }

  removerFiltro() {
    this.search = '';
    this.searchPrograma();
    this.isVisibleCancelFiltro = false;
  }


  searchPrograma() {
    if (this.search !== undefined) {
      this.isVisibleCancelFiltro = true;
      this.loading = true; 
 
      this.programaService.all(this.pageIndex, this.search).subscribe((m: any) => {
        this.pageIndex = 1;
        this.programas = m.data.programa.data;
        this.total = m.data.programa.total;
        this.pageSize = m.data.programa.per_page;
        this.loading = false;
      });
    } else {
      this.message.warning("Digite a sua pesquisa para continuar.");
    }

  }

}
